// Styles
import CashflowForecastContainer from "./CashflowForecast.styles";
import ReportsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ReportsTab/ReportsTab";
import Tabs from "../../../../components/Common/Tabs/Tabs";

interface CashflowForecastProps {}

const CashflowForecast = ({}: CashflowForecastProps) => {
    return (
        <CashflowForecastContainer>
            <p className={"sectionTitle"}>CASHFLOW FORECAST</p>
            <Tabs
                defaultTab="reports"
                tabs={[
                    {
                        value: "reports",
                        title: "REPORTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ReportsTab reportId="2745ada0-1a19-4aa5-ab0a-5c0e5b3f32d6" workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128" />,
                    },
                ]}
            />
        </CashflowForecastContainer>
    );
};

export default CashflowForecast;
